import FORMS_OF_PAYMENT from '../../scripts/constants/forms-of-payment';

class GiftCardFormOfPaymentUIModel {
  constructor({
    cardType,
  }) {
    this.class = FORMS_OF_PAYMENT.GIFT_CARD;
    this.cardType = cardType;
  }
}

export default GiftCardFormOfPaymentUIModel;
